"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceTranslation = void 0;
const typeorm_1 = require("typeorm");
const BaseEntity_1 = require("../../BaseEntity");
let ResourceTranslation = class ResourceTranslation extends BaseEntity_1.BaseEntity {
    constructor(init) {
        super();
        Object.assign(this, init !== null && init !== void 0 ? init : {});
    }
};
exports.ResourceTranslation = ResourceTranslation;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], ResourceTranslation.prototype, "language", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], ResourceTranslation.prototype, "namespace", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], ResourceTranslation.prototype, "key", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], ResourceTranslation.prototype, "translation", void 0);
exports.ResourceTranslation = ResourceTranslation = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Unique)(['language', 'namespace', 'key']),
    __metadata("design:paramtypes", [Object])
], ResourceTranslation);
